import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import App from './App';

import ThemeConfig from './styles/theme';
import './global.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { UserProvider } from 'context/UserContext';
import { GameProvider } from 'context/GameContext';
import { WithDrawRequestProvider } from 'context/WithDrawRequestContext';
import { IssueProvider } from 'context/IssueContext';
import { SocketProvider } from 'context/SocketContext';
import { TicketsProvider } from 'context/TicketsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UserProvider>
          <GameProvider>
            <WithDrawRequestProvider>
              <IssueProvider>
                <SocketProvider>
                  <TicketsProvider>
                    <ThemeConfig>
                      <App />
                      <ToastContainer theme="dark" />
                    </ThemeConfig>
                  </TicketsProvider>
                </SocketProvider>
              </IssueProvider>
            </WithDrawRequestProvider>
          </GameProvider>
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
